<template>
  <div class="fab-chat">
    <div v-show="showPropChat" class="panel panel-default">
      <div class="d-flex bd-highlight">
        <div class="d-flex align-self-center">
          <div class="tpl-avatar-image">
            <div class="lazy-img">
              <div class="bot-avatar-icon">S</div>
            </div>
          </div>
          <span class="bot-name p-2 flex-fill">Simón dice</span>
        </div>
        <div class="ml-auto align-self-center">
          <button class="btn close-button" @click="hideChat()">
            <i class="fa fa-times" />
          </button>
        </div>
        <div class="clearfix" />
      </div>
      <div class="panel-body">
        <div id="webchat" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    profile: {
      type: Object,
      require: true,
      default: () => {}
    },
    showPropChat: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  methods: {
    hideChat() {
      this.$emit("hideChat");
    }
  },
  mounted() {
    const styleSet = window.WebChat.createStyleSet({
      bubbleBackground: "rgba(48 170 125)",
      bubbleBorderRadius: "10px",
      botAvatarBackgroundColor: "rgba(48 170 125)",
      userAvatarBackgroundColor: "rgba(255 112 88)",
      bubbleFromUserBackground: "rgba(255 112 88)",
      bubbleFromUserBorderRadius: "10px",
      rootHeight: "600px",
      rootWidth: "100%",
      suggestedActionBorderColor: "rgba(48 170 125)", // defaults to accent
      suggestedActionBorderStyle: "solid",
      suggestedActionBackground: "red",
      suggestedActionBorder: undefined, // split into 3, null
      suggestedActionTextColor: "rgba(48 170 125)",
      suggestedActionBoarderWidth: 1,
      suggestedActionBorderRadius: 30,
      suggestedActionImageHeight: 20,
      suggestedActionHeight: 35,
    });

    // After generated, you can modify the CSS rules
    styleSet.textContent = {
      ...styleSet.textContent,
      fontFamily: "Lato",
      fontWeight: "100",
      scroll: "",
      color: "#fff"
    };

    // Set the avatar options.
    const styleOptions = {
      botAvatarInitials: "S",
      userAvatarInitials: "U",
      hideUploadButton: true,
      sendBoxTextWrap: true,
      suggestedActionLayout: "stacked" // either 'carousel' or 'stacked'
    };

    var theURL =
      "https://default1c97b514fa3642d0b237aba1a0c4d4.e4.environment.api.powerplatform.com/powervirtualagents/bots/e2475bb0-243f-4d38-8b90-ddb32c73d6e7/directline/token?api-version=2022-03-01-preview";
    var environmentEndPoint = theURL.slice(
      0,
      theURL.indexOf("/powervirtualagents")
    );
    var apiVersion = theURL.slice(theURL.indexOf("api-version")).split("=")[1];
    var regionalChannelSettingsURL = `${environmentEndPoint}/powervirtualagents/regionalchannelsettings?api-version=${apiVersion}`;

    var directline;
    fetch(regionalChannelSettingsURL)
      .then(response => {
        return response.json();
      })
      .then(data => {
        directline = data.channelUrlsById.directline;
      })
      .catch(err => console.error("An error occurred: " + err));

    const store = window.WebChat.createStore(
      {},
      ({ dispatch }) => next => action => {
        if (action.type === "DIRECT_LINE/CONNECT_FULFILLED") {
          dispatch({
            meta: {
              method: "keyboard"
            },
            payload: {
              activity: {
                channelData: {
                  postBack: true
                },
                value: {
                  userId: this.profile.userId,
                  fullName: this.profile.firstname
                },
                name: "startConversation",
                type: "event"
              }
            },
            type: "DIRECT_LINE/POST_ACTIVITY"
          });
        }
        return next(action);
      }
    );

    fetch(theURL)
      .then(response => response.json())
      .then(conversationInfo => {
        window.WebChat.renderWebChat(
          {
            directLine: window.WebChat.createDirectLine({
              domain: `${directline}v3/directline`,
              token: conversationInfo.token
            }),
            store: store,
            styleSet,
            styleOptions
          },
          document.getElementById("webchat")
        );
      })
      .catch(err => console.error("An error occurred: " + err));
  }
};
</script>

<style scoped lang="scss">
.fab-chat {
  position: fixed;
  bottom: 1.4rem;
  right: 8rem;
  float: right;
  z-index: 1000;
  max-width: 370px;
  min-width: 370px;

  .panel {
    background-color: #fff;
    -webkit-box-shadow: rgb(0 0 0 / 25%) 0 4px 16px;
    box-shadow: 0 4px 16px rgb(0 0 0 / 25%);
    border-radius: 15px;
    padding: 4px;
  }

  .btn-circle.btn-xl {
    width: 60px;
    height: 60px;
    padding: 10px 16px;
    border-radius: 35px;
    font-size: 24px;
    line-height: 1.33;
  }

  .btn-circle {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
  }

  .bot-name {
    font-weight: bold;
  }

  .panel-heading {
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 24px;
  }

  .bot-avatar-image {
    width: 40px;
    height: 40px;
    border-radius: 30px;
  }

  .bot-avatar-icon {
    width: 40px;
    height: 40px;
    border-radius: 30px;
    background: #30aa7d;
    text-align: center;
    vertical-align: middle;
    color: #fff;
    padding: 7px;
  }

  .tpl-avatar-image {
    padding-left: 5px;
  }

  .close-button i {
    font-size: 25px;
    font-weight: 100;
  }
}
</style>
